<template>
    <BasePanel 
        headline="lang_AZ_GROUPS_PANEL_CAPTION_FINANCE"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>

            <!-- row for PAYMENT ORDER textarea -->
            <v-row class="pt-4">
                <v-col>
                    <v-textarea class="pl-1 pr-1"
                        v-model="getPaymentOrder"
                        rows="3"
                        :label="$t('lang_GENERAL_CAPTION_PAYMENT_ORDER')"
                        :alvqa="alvqa + '-payment-order'"
                        :disabled="false"
                        :clearable="false"
                        :readonly="true"
                    />
                </v-col>
            </v-row>

            <v-row>

                <!-- column 1: BANK data -->
                <v-col>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getAccountHolder"
                            :label="$t('lang_GENERIC_CAPTION_ACCOUNT_HOLDER')"
                            :alvqa="alvqa + '-account-holder'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getBankName"
                            :label="$t('lang_GENERAL_CAPTION_BANK_NAME')"
                            :alvqa="alvqa + '-bank-name'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getIban"
                            :label="$t('lang_GENERAL_CAPTION_IBAN_ACCOUNT_NO')"
                            :alvqa="alvqa + '-iban'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getBic"
                            :label="$t('lang_GENERAL_CAPTION_BIC_SWIFT_ABA')"
                            :alvqa="alvqa + '-bic'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getPaymentTarget"
                            :label="$t('lang_GENERIC_CAPTION_PAYMENT_TARGET')"
                            :alvqa="alvqa + '-payment-target'"
                        />
                    </v-row>
                </v-col>

                <!-- column 2: TAX data -->
                <v-col>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getVatId"
                            :label="$t('lang_GENERIC_CAPTION_VAT_ID')"
                            :alvqa="alvqa + '-vat-id'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getVatRetail"
                            :label="$t('lang_AZ_PERSONS_CAPTION_VAT_RETAIL')"
                            :alvqa="alvqa + '-vat-retail'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getVatLicense"
                            :label="$t('lang_AZ_PERSONS_CAPTION_VAT_LICENSE')"
                            :alvqa="alvqa + '-vat-license'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxOffice"
                            :label="$t('lang_GENERAL_CAPTION_TAX_OFFICE')"
                            :alvqa="alvqa + '-tax-office'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxNumber"
                            :label="$t('lang_GENERAL_CAPTION_TAX_NO')"
                            :alvqa="alvqa + '-tax-number'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxIdNumber"
                            :label="$t('lang_GENERAL_CAPTION_TAX_ID_GERMAN')"
                            :alvqa="alvqa + '-tax-id-number'"
                        />
                    </v-row>
                </v-col>

                <!-- column 3: COMPANY data -->
                <v-col>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getRegistrationNumber"
                            :label="$t('lang_GENERAL_CAPTION_COMPANY_REGISTRATION_NO')"
                            :alvqa="alvqa + '-registration-number'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getRegisterCourt"
                            :label="$t('lang_GENERAL_CAPTION_REGISTRATION_OFFICE')"
                            :alvqa="alvqa + '-register-court'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxWaiver"
                            :label="$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER')"
                            :alvqa="alvqa + '-dropdown-tax-waiver'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxWaiverFrom"
                            :label="$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER_FROM')"
                            :alvqa="alvqa + '-datepicker-tax-waiver-from'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxWaiverTo"
                            :label="$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER_TO')"
                            :alvqa="alvqa + '-datepicker-tax-waiver-to'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxWithholdingPercentage"
                            :label="$t('lang_AZ_PERSONS_CAPTION_WITHHOLDING_TAX_PERCENTAGE')"
                            :alvqa="alvqa + '-tax-withholding-percentage'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxWithholdingSurchargePercentage"
                            :label="$t('lang_AZ_PERSONS_CAPTION_WITHHOLDING_SURCHARGE_PERCENTAGE')"
                            :alvqa="alvqa + '-tax-withholding-surcharge-percentage'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxLiabilityPercentage"
                            :label="$t('lang_AZ_PERSONS_CAPTION_TAX_LIABILITY_PERCENTAGE')"
                            :alvqa="alvqa + '-tax-liability-percentage'"
                        />
                    </v-row>
                </v-col>

            </v-row>

            <!-- BANK DATA (localized) full width -->
            <v-row>
                <BaseReadOnlyTextField
                    :innerValue="getBankDataLocalized"
                    :label="$t('lang_GENERIC_CAPTION_BANK_DATA_LOCALIZED')"
                    :alvqa="alvqa + '-bank-data-localized'"
                />
            </v-row>

            <v-row>
                <BaseReadOnlyTextField
                    :innerValue="getRecoupmentPriority"
                    :label="$t('lang_AZ_CAPTION_RECOUPMENT_PRIORITY')"
                    :alvqa="alvqa + '-recoupment-priority'"
                />
            </v-row>

            <!-- PUBLISHING STATEMENTS text -->
            <v-row>
                <BaseReadOnlyTextField
                    :innerValue="getPublishingStatementsText"
                    :label="$t('lang_AZ_PERSONS_CAPTION_PUBLISHING_STATEMENTS_TEXT')"
                    :alvqa="alvqa + '-publishing-statements-text'"
                />
            </v-row>

            <!-- LABEL STATEMENTS text -->

            <v-row>
                <BaseReadOnlyTextField
                    :innerValue="getLabelStatementsText"
                    :label="$t('lang_AZ_PERSONS_CAPTION_LABEL_STATEMENTS_TEXT')"
                    :alvqa="alvqa + '-label-statements-text'"
                />
            </v-row>
            
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseReadOnlyTextField from '@/components/_readonly/BaseReadOnlyTextField'
import { DropdownAzTaxWaiver, DropdownAzRecoupmentPriority } from '@/assets/dropdowns/alvDropdowns.js'



export default {
    name: "FinancePanel",
    components: {
        BasePanel,
        BaseReadOnlyTextField,
    },
    props:{
        azGroupsAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: "az-groups-readonly-panel-finance"
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedAzGroups.find(element => {
                return element.id === this.azGroupsAlvId
            })
            return item
        },  
        getPaymentOrder()               { return this.$store.getters.getAzGroupsFinanceDetailsPaymentOrder },
        getAccountHolder()              { return this.$store.getters.getAzGroupsFinanceDetailsAccountHolder },
        getPaymentTarget()              { return this.$store.getters.getAzGroupsFinanceDetailsPaymentTarget },
        getVatId()                      { return this.$store.getters.getAzGroupsFinanceDetailsVatId },
        getIban()                       { return this.$store.getters.getAzGroupsFinanceDetailsIban },
        getVatRetail() { 
            let value = this.$store.getters.getAzGroupsFinanceDetailsVatRetail 
            return (value != null ? value.toString() : '') 
        },
        getVatLicense() { 
            let value = this.$store.getters.getAzGroupsFinanceDetailsVatLicense 
            return (value != null ? value.toString() : '') 
        },
        getTaxOffice()                  { return this.$store.getters.getAzGroupsFinanceDetailsTaxOffice },
        getBic()                        { return this.$store.getters.getAzGroupsFinanceDetailsBic },
        getRegistrationNumber()         { return this.$store.getters.getAzGroupsFinanceDetailsRegistrationNumber },
        getTaxNumber()                  { return this.$store.getters.getAzGroupsFinanceDetailsTaxNumber },
        getBankName()                   { return this.$store.getters.getAzGroupsFinanceDetailsBankName },
        getBankDataLocalized()          { return this.$store.getters.getAzGroupsFinanceDetailsBankDataLocalized },
        getRegisterCourt()              { return this.$store.getters.getAzGroupsFinanceDetailsRegisterCourt },
        getTaxIdNumber()                { return this.$store.getters.getAzGroupsFinanceDetailsTaxIdNumber },
        getTaxWaiver()                  { return this.$store.getters.getAzGroupsFinanceDetailsTaxWaiver },
        getTaxWaiverFrom()              { 
            let date = this.$store.getters.getAzGroupsFinanceDetailsTaxWaiverFrom
            return date ? this.$d(new Date(date), 'alvDateFormat') : ''
        },
        getTaxWaiverTo()                { 
            let date = this.$store.getters.getAzGroupsFinanceDetailsTaxWaiverTo
            return date ? this.$d(new Date(date), 'alvDateFormat') : ''
        },
        getTaxWithholdingPercentage() {
            this.$i18n.locale
            return this.$alvPlugin.getNumberLocalization(
                this.$store.getters.getAzGroupsFinanceDetailsTaxWithholdingPercentage,
                'decimal3'
            )
        },
        getTaxWithholdingSurchargePercentage() {
            this.$i18n.locale
            return this.$alvPlugin.getNumberLocalization(
                this.$store.getters.getAzGroupsFinanceDetailsTaxWithholdingSurchargePercentage,
                'decimal3'
            )
        },
        getTaxLiabilityPercentage() {
            this.$i18n.locale
            return this.$alvPlugin.getNumberLocalization(
                this.$store.getters.getAzGroupsFinanceDetailsTaxLiabilityPercentage,
                'decimal3'
            )
        },
        getRecoupmentPriority() {
            let value = this.$store.getters.getAzGroupsFinanceDetailsRecoupmentPriority
            let item = DropdownAzRecoupmentPriority.find(element => element.value === value)
            return item ? this.$t(item.text) : ''
        },
        getPublishingStatementsText()   { return this.$store.getters.getAzGroupsFinanceDetailsPublishingStatementsText },
        getLabelStatementsText()        { return this.$store.getters.getAzGroupsFinanceDetailsLabelStatementsText },

        getTaxWaiver() { 
            let value = this.$store.getters.getAzGroupsFinanceDetailsTaxWaiver 
            if (value == null) value = 0 // to show new option "not required"
            if (value == "1") value = 1 // temp fix until Goran has fixed BE
            let result = DropdownAzTaxWaiver.find(element => {
                return element.value === value
            }).text
            return this.$t(result)
        },
    },
    created() {
        this.$store.commit('setLanguages')
    },
}
</script>